import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FilterIcon, XIcon } from 'lucide-react';
import { Tooltip } from './ui/Tooltip';
interface GrammarFiltersProps {
  selectedFilters: {
    difficulty: string[];
    category: string[];
  };
  onFilterChange: (category: 'difficulty' | 'category', value: string) => void;
  onClearFilters: () => void;
}
const DIFFICULTIES = [{
  id: 'beginner',
  label: {
    en: 'Beginner',
    ar: 'مبتدئ'
  }
}, {
  id: 'intermediate',
  label: {
    en: 'Intermediate',
    ar: 'متوسط'
  }
}, {
  id: 'advanced',
  label: {
    en: 'Advanced',
    ar: 'متقدم'
  }
}];
const CATEGORIES = [{
  id: 'tenses',
  label: {
    en: 'Tenses',
    ar: 'الأزمنة'
  }
}, {
  id: 'nouns',
  label: {
    en: 'Nouns',
    ar: 'الأسماء'
  }
}, {
  id: 'verbs',
  label: {
    en: 'Verbs',
    ar: 'الأفعال'
  }
}, {
  id: 'adjectives',
  label: {
    en: 'Adjectives',
    ar: 'الصفات'
  }
}];
export function GrammarFilters({
  selectedFilters,
  onFilterChange,
  onClearFilters
}: GrammarFiltersProps) {
  const {
    isArabic
  } = useLanguage();
  const hasActiveFilters = selectedFilters.difficulty.length > 0 || selectedFilters.category.length > 0;
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6" data-id="element-536">
      <div className="flex items-center justify-between mb-6" data-id="element-537">
        <div className="flex items-center gap-2" data-id="element-538">
          <FilterIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" data-id="element-539" />
          <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-540">
            {isArabic ? 'تصفية المواضيع' : 'Filter Topics'}
          </h3>
        </div>
        {hasActiveFilters && <Tooltip content={isArabic ? 'مسح التصفية' : 'Clear filters'} data-id="element-541">
            <button onClick={onClearFilters} className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 flex items-center gap-1" data-id="element-542">
              <XIcon className="w-4 h-4" data-id="element-543" />
              <span data-id="element-544">{isArabic ? 'مسح' : 'Clear'}</span>
            </button>
          </Tooltip>}
      </div>
      <div className="space-y-6" data-id="element-545">
        {/* Difficulty */}
        <div data-id="element-546">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3" data-id="element-547">
            {isArabic ? 'المستوى' : 'Difficulty'}
          </h4>
          <div className="flex flex-wrap gap-2" data-id="element-548">
            {DIFFICULTIES.map(difficulty => <button key={difficulty.id} onClick={() => onFilterChange('difficulty', difficulty.id)} className={`
                  px-3 py-1 rounded-full text-sm font-medium transition-colors
                  ${selectedFilters.difficulty.includes(difficulty.id) ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}
                `} data-id="element-549">
                {isArabic ? difficulty.label.ar : difficulty.label.en}
              </button>)}
          </div>
        </div>
        {/* Categories */}
        <div data-id="element-550">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3" data-id="element-551">
            {isArabic ? 'التصنيفات' : 'Categories'}
          </h4>
          <div className="flex flex-wrap gap-2" data-id="element-552">
            {CATEGORIES.map(category => <button key={category.id} onClick={() => onFilterChange('category', category.id)} className={`
                  px-3 py-1 rounded-full text-sm font-medium transition-colors
                  ${selectedFilters.category.includes(category.id) ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700'}
                `} data-id="element-553">
                {isArabic ? category.label.ar : category.label.en}
              </button>)}
          </div>
        </div>
      </div>
    </div>;
}